export { default as CachePersistor } from './CachePersistor';
export { default as persistCache } from './persistCache';
export * from './persistCacheSync';
export * from './storageWrappers/index';
//# sourceMappingURL=index.js.map